import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import Card from '@material-ui/core/Card'
import Button from '@material-ui/core/Button'
import Hidden from '@material-ui/core/Hidden'
import SvgIcon from '@material-ui/core/SvgIcon'
import { ReactComponent as IconAdd } from 'assets/icons/add.svg'
import Typography from '@material-ui/core/Typography'
import useStyles from './styles'

const ImageCard = props => {
  const { isHighlighted, image, icon, text, textButton, onClick } = props

  const classes = useStyles()

  return (
    <Card elevation={1} component="article" className={classes.root}>
      <div
        className={clsx(classes.header, isHighlighted && classes.isHighlighted)}
      >
        <Hidden smUp>
          <SvgIcon component={icon} className={classes.icon} />
        </Hidden>
        <Hidden xsDown>
          <img src={image} alt={text} />
        </Hidden>
      </div>
      <div className={classes.content}>
        {text ? (
          <Typography variant="body1" component="p" className={classes.text}>
            {text}
          </Typography>
        ) : null}
        {textButton ? (
          <Button
            className={classes.button}
            variant="contained"
            color="primary"
            size="small"
            startIcon={<SvgIcon component={IconAdd} />}
            onClick={onClick}
          >
            {textButton}
          </Button>
        ) : null}
      </div>
    </Card>
  )
}

ImageCard.propTypes = {
  isHighlighted: PropTypes.bool,
  image: PropTypes.any,
  icon: PropTypes.any,
  text: PropTypes.string,
  textButton: PropTypes.string,
  onClick: PropTypes.func,
}

export default ImageCard
